/**
 * Availability copy for the hero badge.
 *
 * The studio books a month ahead, so the badge always names the month after
 * the current one.
 *
 * Computed in the studio's own timezone rather than the server's. Vercel runs
 * in UTC, and Ohio is four or five hours behind it, so a UTC-based calculation
 * would roll the badge over to the following month at 8pm on the last evening
 * of the current one -- while it is still, to everyone reading the page, the
 * month before.
 */

/* Cincinnati, Ohio. */
const STUDIO_TZ = 'America/New_York';

export function nextBookingMonth(now: Date = new Date()): string {
  const month = Number(
    new Intl.DateTimeFormat('en-US', {
      timeZone: STUDIO_TZ,
      month: 'numeric',
    }).format(now),
  );

  /* `month` is 1-12 and JS month indices are 0-11, so the current month number
     is already the index of the *next* month, and December (12) wraps to
     January (0) for free.

     Naming it from day 1 of an arbitrary year avoids the classic overflow bug:
     setMonth(+1) on the 31st of a 31-day month lands in the month after next,
     because the 31st does not exist in between. */
  const nextIndex = month % 12;

  return new Date(Date.UTC(2000, nextIndex, 1)).toLocaleString('en-US', {
    month: 'long',
    timeZone: 'UTC',
  });
}
